<template>
  <div class="transaction-detail">
    <!-- 头部 -->
    <header>
      <div class="g-header">
        <div class="left" @click="changego">
          <van-icon name="arrow-left" color="#fff" size="20px" />
        </div>
        <div class="middle fs-18">交易明细</div>
        <div class="right"></div>
      </div>
    </header>

    <!-- 标签栏 -->
    <div class="tab-bar">
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 'all' }"
        @click="switchTab('all')"
      >
        全部
      </div>
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 'income' }"
        @click="switchTab('income')"
      >
        收入
      </div>
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 'expense' }"
        @click="switchTab('expense')"
      >
        支出
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-area">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="--END--"
          @load="onLoad"
        >
          <!-- 空数据 -->
          <div class="empty-state" v-if="filteredList.length === 0">
            <img src="@/assets/image/czbg.png" class="empty-image" alt=""/>
            <p class="empty-tip">没有任何记录</p>
            <p class="empty-subtitle">和往常一样，这里什么都没</p>
          </div>
          
          <!-- 交易列表 -->
          <div class="transaction-list" v-else>
            <div 
              class="transaction-item" 
              v-for="(item, index) in filteredList" 
              :key="index"
            >
              <div class="item-left">
                <div class="transaction-type">{{ item.type }}</div>
                <div class="transaction-time">{{ timeStr(item.createtime) }}</div>
              </div>
              <div class="item-right">
                <div class="amount" :class="item.amount > 0 ? 'positive' : 'negative'">
                  {{ item.amount > 0 ? '+' : '' }}{{ item.amount }}
                </div>
                <div class="points">积分: {{ item.points }}</div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import time from "@/utils/time";
import userApi from "@/api/user";

export default {
  name: "BetRecord",
  data() {
    return {
      activeTab: 'all', // 当前选中的标签
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      transactionData: [], // 从API获取的交易数据
      // 模拟数据，实际应该从API获取
      mockData: [
        {
          type: '奖励',
          createtime: 1698062413,
          amount: 284.00,
          points: 100000,
          category: 'income'
        },
        {
          type: '奖励',
          createtime: 1698062413,
          amount: 246.00,
          points: 99716,
          category: 'income'
        },
        {
          type: '奖励',
          createtime: 1698062412,
          amount: 246.00,
          points: 99470,
          category: 'income'
        },
        {
          type: '奖励',
          createtime: 1698062406,
          amount: 246.00,
          points: 99224,
          category: 'income'
        },
        {
          type: '交易',
          createtime: 1698059937,
          amount: -123.00,
          points: 98978,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059933,
          amount: -142.00,
          points: 99101,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059933,
          amount: -142.00,
          points: 99243,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059919,
          amount: -123.00,
          points: 99385,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059919,
          amount: -123.00,
          points: 99508,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059919,
          amount: -123.00,
          points: 99631,
          category: 'expense'
        }
      ]
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === 'all') {
        return this.transactionData;
      } else if (this.activeTab === 'income') {
        return this.transactionData.filter(item => item.category === 'income');
      } else if (this.activeTab === 'expense') {
        return this.transactionData.filter(item => item.category === 'expense');
      }
      return [];
    }
  },
  methods: {
    timeStr(timestamp) {
      return time.formatDatethree(timestamp * 1000);
    },
    async BtnOk() {
      this.$toast.loading({
        message: '加载中',
        duration: 0,
        forbidClick: true,
      });
      
      try {
        // 获取当前日期和30天前的日期
        const endDate = new Date();
        const beginDate = new Date();
        beginDate.setDate(beginDate.getDate() - 30);
        
        const beginDateStr = this.formatDate(beginDate);
        const endDateStr = this.formatDate(endDate);
        
        // 调用真实API
        const response = await userApi.transactionDetails(beginDateStr, endDateStr);
        
        if (response.code === 1) {
          // 处理返回的数据，转换为前端需要的格式
          this.transactionData = this.processTransactionData(response.data);
          this.list = this.transactionData;
        } else {
          this.$toast.fail(response.msg || '获取数据失败');
        }
        
        this.loading = false;
        this.finished = true;
        this.$toast.clear();
      } catch (error) {
        console.error('获取交易数据失败:', error);
        this.$toast.fail('网络错误，请稍后重试');
        this.loading = false;
        this.$toast.clear();
      }
    },
    onRefresh() {
      this.refreshing = false;
      this.finished = false;
      this.loading = true;
      this.BtnOk();
    },
    changego() {
      this.$router.go(-1);
    },
    // 切换标签
    switchTab(tab) {
      this.activeTab = tab;
      // 重新加载数据
      this.onRefresh();
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.BtnOk();
      }
    },
    changeDetail(item) {
      this.$router.push({
        path: "/betDetail",
        query: { item: JSON.stringify(item) },
      });
    },
    // 格式化日期为 YYYY-MM-DD 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 处理API返回的交易数据，转换为前端需要的格式
    processTransactionData(data) {
      return data.map(item => {
        // 根据type判断收入还是支出
        let category = 'income'; // 默认收入
        let amount = parseFloat(item.quantity);
        
        // 根据type_text判断类型
        if (item.type_text === '提现' || item.type_text === '交易') {
          category = 'expense';
          amount = -Math.abs(amount); // 支出显示为负数
        }
        
        return {
          id: item.id,
          type: item.type_text, // 使用中文类型名称
          createtime: item.createtime,
          amount: amount,
          points: parseInt(item.over), // 余额作为积分
          category: category,
          status: item.status_text, // 状态中文名称
          mark: item.mark || '', // 备注
          original: item // 保留原始数据
        };
      });
    },
  },
  mounted() {
    this.onRefresh();
  },
};
</script>

<style lang="less" scoped>
.transaction-detail {
  background: #050925;
  height: 100vh;
  color: #fff;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.g-header {
  background: #050925;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  flex-shrink: 0;
  position: relative;
  z-index: 20;
}

.left {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.middle {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
}

.right {
  width: 44px;
}

.tab-bar {
  display: flex;
  background: #050925;
  /* border-bottom: 1px solid #2a3a5c; */
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 16px 0;
  font-size: 16px;
  color: #8a9bb8;
  position: relative;
  cursor: pointer;
  
  &.active {
    color: #d4d5ea;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: #fff;
    }
  }
}

.content-area {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
  background: #050925;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-image {
  width: 58%;
  display: block;
  margin: 0 auto 20px auto;
}

.empty-tip {
  font-size: 18px;
  color: #9c9497;
  // margin-bottom: 10px;
}

.empty-subtitle {
  font-size: 14px;
  color: #9c9497;
  margin: 0;
}

.transaction-list {
  /* padding-top: 16px; */
}

.transaction-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.item-left {
  flex: 1;
}

.transaction-type {
  font-size: 18px;
  color: #fff;
  margin-bottom: 10px;
  text-align: left;
}

.transaction-time {
  font-size: 17px;
  color: #87827c;
  text-align: left;
}

.item-right {
  text-align: right;
}

.amount {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
  
  &.positive {
    color: #aa3136;
  }
  
  &.negative {
    color: #3c7143;
  }
}

.points {
  font-size: 17px;
  color: #87827c;
}

// 覆盖vant组件样式
:deep(.van-pull-refresh) {
  background: transparent;
  height: auto;
  overflow: visible;
}

:deep(.van-list) {
  background: transparent;
  height: auto;
  overflow: visible;
}

:deep(.van-loading) {
  color: #fff;
}

:deep(.van-list__finished-text) {
  color: #8a9bb8;
}
</style>